/**
 * A global namespace for `dragend` event.
 */
const dragendEvent = "dragend";
export default dragendEvent;
